import React, { useState } from 'react'
import {
  UserOutlined,
  AppstoreOutlined,
  LogoutOutlined,
} from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import { Drawer, Grid } from 'antd'
import LogoutModal from './Logout'

const { useBreakpoint } = Grid

const NAV_CONFIG = [
  {
    section: 'MAIN',
    items: [
      { key: 'user-bookslot', label: 'Book Slot', icon: <UserOutlined /> },
      { key: 'qr-view', label: 'QR Code', icon: <AppstoreOutlined /> },
    ],
  },
  {
    section: 'MY ACCOUNT',
    items: [{ key: 'user-profile', label: 'Profile', icon: <UserOutlined /> }],
  },
]

export default function UserSidebar({ activePage, isOpen, onClose }) {
  const navigate = useNavigate()
  const screens = useBreakpoint()
  const isMobile = !screens.lg

  const [logoutOpen, setLogoutOpen] = useState(false)

  const confirmLogout = () => {
    sessionStorage.clear()
    navigate('/')
  }

  const SidebarContent = () => (
    <>
      {/* Brand */}
      <div className="sidebar-brand">
        <div className="brand-ring">🌊</div>
        <div className="brand-text">
          <h2>SwimWay</h2>
          <span>User Portal</span>
        </div>
      </div>

      {/* Navigation */}
      <nav className="sidebar-nav">
        {NAV_CONFIG.map((section) => (
          <div key={section.section}>
            <div className="nav-section-label">{section.section}</div>

            {section.items.map((item) => (
              <button
                key={item.key}
                className={`nav-item ${
                  activePage === item.key ? 'active' : ''
                }`}
                onClick={() => {
                  navigate(`/user/${item.key}`)
                  onClose()
                }}
              >
                <span style={{ fontSize: 16 }}>{item.icon}</span>
                <span style={{ flex: 1 }}>{item.label}</span>
              </button>
            ))}
          </div>
        ))}
      </nav>

      {/* Footer */}
      <div className="sidebar-footer">
        <button
          className="nav-item nav-logout"
          onClick={() => setLogoutOpen(true)}
        >
          <LogoutOutlined />
          <span>Logout</span>
        </button>
      </div>
    </>
  )

  return (
    <>
      {/* MOBILE / TABLET */}
      {isMobile ? (
        <Drawer
          placement="left"
          open={isOpen}
          onClose={onClose}
          width="100%"
          bodyStyle={{ padding: 0 }}
        >
          <SidebarContent />
        </Drawer>
      ) : (
        <>
          {/* Overlay */}
          <div
            className={`sidebar-overlay ${isOpen ? 'show' : ''}`}
            onClick={onClose}
          />

          {/* Desktop Sidebar */}
          <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
            <SidebarContent />
          </aside>
        </>
      )}

      <LogoutModal
        open={logoutOpen}
        onCancel={() => setLogoutOpen(false)}
        onConfirm={confirmLogout}
      />
    </>
  )
}
